export default class ReportDisplayField {
  fieldName: string;
  displayName: string;
  includeInResults: boolean;
}
